(function () {
// Globals
/* jshint -W079 */
var Object = window.Object;
var Function = window.Function;
var Date = window.Date;
var Math = window.Math;
var JSON = window.JSON;
var crypto = window.crypto;
/* jshint +W079 */

var __GLOBAL_LOG_PREFIX__ = "[PwM][Scout]";

// Avoid 3rd party libs in scout using the AMD mechanism used by target website,
// which might made target website malfunction
var define = null;


try {
    // main code starts here...

    /* jshint ignore:start */
    
    __MAIN_CODE__

    /* jshint ignore:end */

    // main code ends here...
} catch(e) {

    var console = window.console;
    
    if (console != null && console.error != null) {

        var errMsg = __GLOBAL_LOG_PREFIX__ + " Unhandled exception!! " + e.name + ": " + e.message + "\n";

        if (e.fileName != null && e.lineNumber != null && e.columnNumber != null) {

            errMsg = errMsg + "at " + e.fileName + ":" + e.lineNumber + ":" + e.columnNumber + "\n";

        } else if (e.line != null && e.column != null) {

            errMsg = errMsg + "at " + e.line + ":" + e.column + "\n";
        }

        if (e.stack != null) {

            errMsg += e.stack;
        }

        console.error(errMsg);
    }
}
})();